import DOMPurify, { type Config } from 'dompurify';
import { marked } from 'marked';

/**
 * Strip the `<measured-context>` tenant preamble defensively before parsing,
 * mirroring `contentToText`. Catches the edge case where an agent echoes the
 * block back instead of stripping it from its own response.
 */
const TENANT_CONTEXT_BLOCK =
  /<measured-context\b[\s\S]*?<\/measured-context>/gi;

const SANITIZE_CONFIG: Config = {
  ALLOWED_TAGS: [
    'p',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'ul',
    'ol',
    'li',
    'code',
    'pre',
    'blockquote',
    'hr',
    'table',
    'thead',
    'tbody',
    'tr',
    'th',
    'td',
    'a',
    'strong',
    'em',
    'br',
    'span'
  ],
  ALLOWED_ATTR: ['href', 'target', 'rel'],
  ALLOW_DATA_ATTR: false
};

/**
 * Parse agent markdown into sanitized HTML. Wrap the result in a
 * `prose prose-sm max-w-none` div for styling — every element type
 * is then styled by the typography plugin's design-token overrides
 * (see libs/design-system/tailwind.config.js).
 */
export function renderAgentMarkdown(input: string | null | undefined): string {
  if (!input) return '';
  const cleaned = input.replace(TENANT_CONTEXT_BLOCK, '').trim();
  if (!cleaned) return '';
  const html = marked.parse(cleaned, { async: false, gfm: true }) as string;
  return DOMPurify.sanitize(html, SANITIZE_CONFIG) as unknown as string;
}
